import script from "./RoleTimeFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleTimeFooter.vue?vue&type=script&setup=true&lang=ts"

import "./RoleTimeFooter.vue?vue&type=style&index=0&id=6002ba9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6002ba9b"]])

export default __exports__